import React from 'react';
import style from './style.module.scss';
import { MiniTitle } from '@/ui';
import { useFetch } from '@/hooks';
import { NoImage } from '..';
import nullPoster from '@/public/not-image.png';
import Image from 'next/image';

export const Videomaterials = async () => {
  const { data } = await useFetch(process.env.NEXT_PUBLIC_API_URL + '/videomaterialy?populate=*');

  // Функция для преобразования ссылки
  const getEmbedUrl = (url?: string) => {
    if (!url) return '';
    return url.replace('/video/', '/play/embed/');
  };

  return (
    <div className={style.wrapper}>
      {data && (
        <>
          <div className={style.top}>
            <MiniTitle text="Видео" />
          </div>
          <div className={style.content}>
            <div className={style.item}>
              {data?.one_video_link ? (
                <iframe
                  width="720"
                  // height="205"
                  src={getEmbedUrl(data?.one_video_link)}
                  allow="clipboard-write; autoplay"
                  //@ts-ignore
                  webkitAllowFullScreen
                  mozallowfullscreen
                  allowFullScreen></iframe>
              ) : (
                <Image width="200" height="405" src={nullPoster} alt="poster" />
              )}
            </div>
            <div className={style.item}>
              {data?.two_video_link ? (
                <iframe
                  width="720"
                  // height="auto"
                  src={getEmbedUrl(data?.two_video_link)}
                  allow="clipboard-write; autoplay"
                  //@ts-ignore
                  webkitAllowFullScreen
                  mozallowfullscreen
                  allowFullScreen></iframe>
              ) : (
                <Image width="200" height="405" src={nullPoster} alt="poster" />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
